"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.JustPagerLayout = exports.AllPagerLayout = exports.YearPagerLayout = exports.MonthPagerLayout = exports.MonthPagerLayoutWithoutMemo = void 0;

var _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _slicedToArray2 = require("babel-runtime/helpers/slicedToArray"),
    _slicedToArray3 = _interopRequireDefault(_slicedToArray2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require("prop-types"),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _reactRedux = require("react-redux"),
    _Text = require("office-ui-fabric-react/lib/Text"),
    _formatting = require("../../formatting"),
    _reactReduxFirebase = require("react-redux-firebase"),
    _get = require("lodash/get"),
    _get2 = _interopRequireDefault(_get),
    _officeUiFabricReact = require("office-ui-fabric-react"),
    _reactHooks = require("@uifabric/react-hooks"),
    _lodash = require("lodash"),
    _monthName = require("../../libs/monthName"),
    _monthName2 = _interopRequireDefault(_monthName),
    _dateOffset = require("../../libs/dateOffset"),
    _dateOffset2 = _interopRequireDefault(_dateOffset),
    _Paginate = require("../Paginate"),
    _Spinner = require("office-ui-fabric-react/lib/Spinner"),
    _RenderTable = require("../RenderTable"),
    _SaveExcel = require("../SaveExcel"),
    _SaveExcel2 = _interopRequireDefault(_SaveExcel),
    _ListWithLoader = require("../ListWithLoader"),
    _ListWithLoader2 = _interopRequireDefault(_ListWithLoader),
    _useStorage = require("../../libs/useStorage");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var WarningLightButton = _officeUiFabricReact.DefaultButton,
    firstDay = function firstDay() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : "";

  if (!a) {
    var b = new Date();
    return b.setDate(1), (0, _formatting.formatSys2OdooDate)(b);
  }

  return a + "-01";
},
    MonthPagerLayoutWithoutMemo = exports.MonthPagerLayoutWithoutMemo = function (a) {
  var b = a.monthSessionKey,
      c = a.monthSelector,
      d = a.monthDispatcher,
      e = a.headerStyle,
      f = void 0 === e ? {
    backgroundColor: "#b4a0ff"
  } : e,
      g = a.noItemMsg,
      h = void 0 === g ? "No Records Found" : g,
      i = a.mainTitle,
      j = void 0 === i ? "Title" : i,
      k = a.mainTitleIcon,
      l = void 0 === k ? null : k,
      m = a.renderItem,
      n = (0, _useStorage.useStateWithSessionStorage)(b, firstDay()),
      o = (0, _slicedToArray3.default)(n, 2),
      p = o[0],
      q = o[1],
      r = p.substring(0, 7),
      s = (0, _reactRedux.useSelector)(function (a) {
    return c(a, r);
  }),
      t = s.isLoading,
      u = s.recs,
      v = (0, _reactRedux.useDispatch)(); // const [curdate, setCurDate] = useState(
  //   firstDay()
  // );

  (0, _react.useEffect)(function () {
    v(d(r));
  }, [r]);
  var w = (0, _ListWithLoader.useListWithLoader)({
    showLoader: !0,
    showItems: !1,
    items: [],
    itemKey: "id",
    CustomComponent: function c(a) {
      var b = a.item;
      return m(b);
    },
    noItemsMsg: "No Items"
  });
  return _react2.default.useEffect(function () {
    var a = !t && (!u || !u.length);
    t ? w.setState(function (a) {
      return (0, _extends3.default)({}, a, {
        showItems: !1,
        showNoItemsMsg: !1,
        showLoader: !0
      });
    }) : a && w.setState(function (a) {
      return (0, _extends3.default)({}, a, {
        showItems: !1,
        showNoItemsMsg: !0,
        showLoader: !1
      });
    });
  }, [t]), _react2.default.useEffect(function () {
    var a = u.length;
    a && w.setState(function (a) {
      return (0, _extends3.default)({}, a, {
        showLoader: !1,
        showItems: !0,
        showNoItemsMsg: !1,
        items: u
      });
    });
  }, [u]), _react2.default.createElement("div", {
    className: "card mb-2 "
  }, _react2.default.createElement("div", {
    style: f,
    className: "card-header  text-center   p-3"
  }, l && _react2.default.createElement(_Text.Text, {
    variant: "mediumPlus"
  }, _react2.default.createElement(_officeUiFabricReact.Icon, {
    iconName: l
  })), " ", _react2.default.createElement(_Text.Text, {
    variant: "large"
  }, j)), _react2.default.createElement("div", {
    className: "card-header  text-center p-1"
  }, _react2.default.createElement(_Paginate.Paginate, {
    content: _react2.default.createElement("b", null, (0, _monthName2.default)(p)),
    back: function a() {
      q((0, _dateOffset2.default)(p, -1, "month"));
    },
    fwd: function a() {
      q((0, _dateOffset2.default)(p, 1, "month"));
    },
    forceBackFwd: !0
  })), _react2.default.createElement(_ListWithLoader2.default, w));
};
/** MonthPagerLayout */


MonthPagerLayoutWithoutMemo.propTypes = {
  monthSessionKey: _propTypes2.default.string,
  monthSelector: _propTypes2.default.func,
  monthDispatcher: _propTypes2.default.func,
  headerStyle: _propTypes2.default.object,
  noItemMsg: _propTypes2.default.string,
  mainTitle: _propTypes2.default.string,
  mainTitleIcon: _propTypes2.default.any,
  renderItem: _propTypes2.default.func
};

var MonthPagerLayout = exports.MonthPagerLayout = _react2.default.memo(MonthPagerLayoutWithoutMemo),
    YearPagerLayout = exports.YearPagerLayout = _react2.default.memo(function (a) {
  var b = a.yearSessionKey,
      c = a.yearSelector,
      d = a.yearDispatcher,
      e = a.headerStyle,
      f = e === void 0 ? {
    backgroundColor: "#b4a0ff"
  } : e,
      g = a.noItemMsg,
      h = g === void 0 ? "No Records Found" : g,
      i = a.mainTitle,
      j = i === void 0 ? "Title" : i,
      k = a.mainTitleIcon,
      l = k === void 0 ? null : k,
      m = a.renderItem,
      n = (0, _useStorage.useStateWithSessionStorage)(b, firstDay()),
      o = (0, _slicedToArray3.default)(n, 2),
      p = o[0],
      q = o[1],
      r = p.substring(0, 4),
      s = (0, _reactRedux.useSelector)(function (a) {
    return c(a, r);
  }),
      t = s.isLoading,
      u = s.recs,
      v = (0, _reactRedux.useDispatch)(); // const [curdate, setCurDate] = useState(
  //   firstDay()
  // );

  (0, _react.useEffect)(function () {
    v(d(r));
  }, [r]);
  return _react2.default.createElement("div", {
    className: "card mb-2 "
  }, _react2.default.createElement("div", {
    style: f,
    className: "card-header  text-center   p-3"
  }, l && _react2.default.createElement(_Text.Text, {
    variant: "mediumPlus"
  }, _react2.default.createElement(_officeUiFabricReact.Icon, {
    iconName: l
  })), " ", _react2.default.createElement(_Text.Text, {
    variant: "large"
  }, j)), _react2.default.createElement("div", {
    className: "card-header  text-center p-1"
  }, _react2.default.createElement(_Paginate.Paginate, {
    content: _react2.default.createElement("b", null, r),
    back: function a() {
      q((0, _dateOffset2.default)(p, -1, "year"));
    },
    fwd: function a() {
      q((0, _dateOffset2.default)(p, 1, "year"));
    },
    forceBackFwd: !0
  })), _react2.default.createElement(_officeUiFabricReact.Stack, {
    className: "list-group list-group-flush"
  }, t && _react2.default.createElement(_Spinner.Spinner, {
    size: _Spinner.SpinnerSize.large
  }), u.map(function (a) {
    return _react2.default.createElement(_officeUiFabricReact.Stack.Item, {
      className: "list-group-item",
      key: a.id
    }, m(a, r));
  }), 0 === u.length && !t && _react2.default.createElement(_officeUiFabricReact.Stack.Item, {
    className: "list-group-item"
  }, _react2.default.createElement(_Text.Text, null, h))));
}),
    AllPagerLayout = exports.AllPagerLayout = _react2.default.memo(function (a) {
  var b = a.allSelector,
      c = a.allDispatcher,
      d = a.headerStyle,
      e = void 0 === d ? {
    backgroundColor: "#b4a0ff"
  } : d,
      f = a.noItemMsg,
      g = void 0 === f ? "No Records Found" : f,
      h = a.mainTitle,
      i = void 0 === h ? "Title" : h,
      j = a.mainTitleIcon,
      k = void 0 === j ? null : j,
      l = a.renderItem,
      m = (0, _reactRedux.useSelector)(b),
      n = m.isLoading,
      o = m.recs,
      p = (0, _reactRedux.useDispatch)();
  return (0, _react.useEffect)(function () {
    p(c());
  }, []), _react2.default.createElement("div", {
    className: "card mb-2 "
  }, _react2.default.createElement("div", {
    style: e,
    className: "card-header  text-center   p-3"
  }, k && _react2.default.createElement(_Text.Text, {
    variant: "mediumPlus"
  }, _react2.default.createElement(_officeUiFabricReact.Icon, {
    iconName: k
  })), " ", _react2.default.createElement(_Text.Text, {
    variant: "large"
  }, i)), _react2.default.createElement(_officeUiFabricReact.Stack, {
    className: "list-group list-group-flush"
  }, n && _react2.default.createElement(_Spinner.Spinner, {
    size: _Spinner.SpinnerSize.large
  }), o.map(function (a) {
    return _react2.default.createElement(_officeUiFabricReact.Stack.Item, {
      className: "list-group-item",
      key: a.id
    }, l(a));
  }), 0 === o.length && !n && _react2.default.createElement(_officeUiFabricReact.Stack.Item, {
    className: "list-group-item"
  }, _react2.default.createElement(_Text.Text, null, g))));
}),
    dfltSortKey = {
  text: "Sort By",
  f: function b(c, a) {
    return c.name > a.name;
  }
},
    JustPagerLayout = exports.JustPagerLayout = _react2.default.memo(function (a) {
  var b = a.justSessionKey,
      c = a.justSelector,
      d = a.justDispatcher,
      e = a.justOptions,
      f = e === void 0 ? [{
    key: "",
    text: "No Keys Passed"
  }] : e,
      g = a.headerStyle,
      h = g === void 0 ? {
    backgroundColor: "white"
  } : g,
      i = a.commandBarProps,
      j = a.noItemMsg,
      k = j === void 0 ? "No Records Found" : j,
      l = a.mainTitle,
      m = l === void 0 ? "Title" : l,
      n = a.mainTitleIcon,
      o = n === void 0 ? null : n,
      p = a.renderItem,
      q = a.colDefns,
      r = a.showTableHeader,
      s = a.tableUDButtons,
      t = s === void 0 ? null : s,
      u = a.passConfig,
      v = a.displayAsTable,
      w = a.excelColDefns,
      x = w === void 0 ? null : w,
      y = a.optionSelector,
      z = a.filterProps,
      A = z === void 0 ? {
    placeholder: "Search",
    filterMenuItems: [],
    searchFunction: null
  } : z,
      B = (0, _useStorage.useStateWithSessionStorage)(b, 0),
      C = (0, _slicedToArray3.default)(B, 2),
      D = C[0],
      E = C[1],
      F = (0, _get2.default)(f, [D, "key"], 0 < f.length ? f[0].key : ""),
      G = (0, _get2.default)(f, [D, "text"], 0 < f.length ? f[0].text : "--"),
      H = (0, _reactRedux.useSelector)(function (a) {
    return c(a, F);
  }),
      I = (0, _reactRedux.useDispatch)(); // const [curKeyIdx, setCurKeyIdx] = useState(
  //   0
  // );
  // console.log("curKeyIdx", curKeyIdx, justOptions);

  (0, _react.useEffect)(function () {
    d && I(d(F));
  }, [F]);

  var J = (0, _react.useCallback)(function () {
    E(function (a) {
      return 0 < a ? a - 1 : a;
    });
  }, []),
      K = (0, _react.useCallback)(function () {
    E(function (a) {
      return a < f.length - 1 ? a + 1 : a;
    });
  }, [f.length]),
      L = (0, _react.useCallback)(function (a) {
    return E(f.findIndex(function (b) {
      return b.key === a;
    }));
  }, [f]),
      M = (0, _reactHooks.useBoolean)(!1),
      N = (0, _slicedToArray3.default)(M, 2),
      O = N[0],
      P = N[1].toggle,
      Q = (0, _react.useState)(""),
      R = (0, _slicedToArray3.default)(Q, 2),
      S = R[0],
      T = R[1],
      U = (0, _react.useState)(dfltSortKey),
      V = (0, _slicedToArray3.default)(U, 2),
      W = V[0],
      X = V[1],
      Y = (0, _react.useMemo)(function () {
    var a = W.sf,
        b = a === void 0 ? function () {
      return !0;
    } : a,
        c = !S || !A || !A.searchFunction;
    return !H || 1 > H.length ? [] : H.filter(function (a) {
      return c || -1 < A.searchFunction(a).toLowerCase().search(S);
    }).filter(b).sort(W.f);
  }, [H, S, W]),
      Z = (0, _react.useCallback)(function () {
    P(), T(""), X(dfltSortKey);
  }),
      $ = 1 < f.length && _react2.default.createElement("span", null, " ", _react2.default.createElement(_officeUiFabricReact.Icon, {
    iconName: "Filter"
  }), " ");

  return _react2.default.createElement("div", {
    className: "card mb-2 "
  }, _react2.default.createElement("div", {
    style: h,
    className: "p-3"
  }, _react2.default.createElement(_officeUiFabricReact.Stack, {
    horizontal: !0,
    wrap: !0,
    horizontalAlign: "space-between"
  }, _react2.default.createElement(_officeUiFabricReact.Stack.Item, null, o && _react2.default.createElement(_Text.Text, {
    variant: "xLarge"
  }, _react2.default.createElement(_officeUiFabricReact.Icon, {
    iconName: o
  })), " ", _react2.default.createElement(_Text.Text, {
    variant: "xxLarge"
  }, m)), !!i && _react2.default.createElement(_officeUiFabricReact.Stack.Item, null, _react2.default.createElement(_officeUiFabricReact.CommandBar, i)))), _react2.default.createElement("div", {
    style: {
      backgroundColor: "#eee"
    }
  }, _react2.default.createElement(_Paginate.Paginate, {
    contentOptionsPrefix: $,
    contentOptions: !(y !== void 0) || y ? f : null,
    onSelect: L,
    disableBack: 0 >= D,
    disableFwd: D >= f.length - 1,
    content: _react2.default.createElement("b", null, (0, _reactReduxFirebase.isLoaded)(H) ? G : "No Records"),
    back: J,
    fwd: K,
    postcontent: 0 < f.length && _react2.default.createElement(_react2.default.Fragment, null, x && _react2.default.createElement(_SaveExcel2.default, {
      btnProps: {
        type: "action",
        title: "Download Excel",
        iconProps: {
          iconName: "Download"
        }
      },
      jsonTable: Y,
      fileName: "ExcelDump.csv",
      colDefns: x
    }), (!!A.searchFunction || !!A.filterMenuItems && 0 < A.filterMenuItems.length) && _react2.default.createElement(_officeUiFabricReact.ActionButton, {
      title: "show/hide search and filters",
      style: {
        backgroundColor: O ? "lightgrey" : ""
      },
      iconProps: {
        iconName: O ? "Cancel" : "Search"
      },
      onClick: Z
    }))
  })), O && !!A.searchFunction && _react2.default.createElement(_officeUiFabricReact.Stack, {
    horizontal: !0,
    wrap: !0,
    tokens: {
      childrenGap: 10,
      padding: 10
    }
  }, _react2.default.createElement(_officeUiFabricReact.Stack.Item, null, _react2.default.createElement(_officeUiFabricReact.SearchBox, {
    styles: {
      root: {
        minWidth: "160px",
        maxWidth: "200px"
      }
    },
    placeholder: A.placeholder,
    onChange: (0, _lodash.debounce)(function (a, b) {
      return T(b.toLowerCase());
    }, 300, {
      trailing: !0
    }),
    onEscape: function a() {
      return T("");
    },
    iconProps: {
      iconName: "Search"
    }
  })), !!A && "filterMenuItems" in A && !!A.filterMenuItems && 0 < A.filterMenuItems.length && _react2.default.createElement(WarningLightButton, {
    text: W.text,
    menuProps: {
      items: A.filterMenuItems,
      onItemClick: function c(a, b) {
        return a.preventDefault(), X(b), !0;
      }
    }
  })), _react2.default.createElement(_officeUiFabricReact.Stack, {
    className: "list-group list-group-flush"
  }, !(0, _reactReduxFirebase.isLoaded)(H) && _react2.default.createElement(_Spinner.Spinner, {
    size: _Spinner.SpinnerSize.large
  }), (0, _reactReduxFirebase.isLoaded)(H) && 0 <= H.length && _react2.default.createElement(_react2.default.Fragment, null, v !== void 0 && v ? _react2.default.createElement(_RenderTable.RenderTableData, {
    showHeader: r !== void 0 && r,
    colDefns: q,
    rowData: Y,
    udButtons: t,
    passConfig: u
  }) : Y.map(function (a, b) {
    return _react2.default.createElement(_officeUiFabricReact.Stack.Item, {
      styles: {
        root: {
          borderBottom: "solid 1px #ddd",
          padding: 6
        }
      },
      key: b
    }, p(a, F));
  })), 0 === Y.length && (0, _reactReduxFirebase.isLoaded)(H) && _react2.default.createElement(_officeUiFabricReact.Stack.Item, {
    className: "list-group-item"
  }, _react2.default.createElement(_Text.Text, null, k))));
});